import { useEffect, useRef } from 'react';
import { isSafari } from '@/utils/browser-kit';
import { loadImageAsync } from '@/utils/file-kit';

const Mask: React.FC<{
    maskURL: string;
    stageWidth: number;
    stageHeight: number;
    isOperating: boolean;
    scale: number;
}> = ({ maskURL, stageWidth, stageHeight, isOperating, scale }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (isOperating || !maskURL) {
            return;
        }
        let isCancelled = false;
        const renderMask = async () => {
            const img = await loadImageAsync(maskURL, false);
            if (isCancelled) {
                return;
            }

            const canvas = canvasRef.current;
            if (!canvas) {
                return;
            }
            canvas.width = Math.round(stageWidth * scale);
            canvas.height = Math.round(stageHeight * scale);
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = 'rgba(255,255,255,0.9)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = 'destination-out';
            if (isSafari) {
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
            } else {
                ctx.drawImage(img, 0, 0);
            }
            ctx.globalCompositeOperation = 'source-over';
        };
        renderMask();
        return () => {
            isCancelled = true;
        };
    }, [maskURL, stageWidth, stageHeight, isOperating, scale]);

    if (!maskURL || isOperating) {
        return null;
    }

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: `${stageWidth * scale}px`,
                height: `${stageHeight * scale}px`,
            }}
        ></canvas>
    );
};

export default Mask;
